import React, { useContext, useEffect } from 'react';
import { AppContext } from './context/AppContext';
import ReturnHome from './ReturnHome';

function SetTeamsMain(props) {
    const { FLAGS, teams, setTeams } = useContext(AppContext);

    useEffect(() => {
        // every time I go to the main page, close the popup
        props.hideHamburger();
    }, [])

    const handleChange = (e) => {
        const { name, value } = e.target;
        setTeams(prevStruct => ({
            ...prevStruct,
            [name]: value
        }));
    };

    return (
        <div>
            <h1>Team Info</h1>
            <div className="editTeamNames">
                <div className='TeamInfoCard'>
                    <div>Home Team Name</div>
                    <input type='text' onInput={handleChange} name='homeShortName'
                        placeholder="Enter away team name"
                        value={teams.homeShortName} />
                    <div>Division</div>
                    <input type='text' onInput={handleChange} name='homeAgeDivision' value={teams.homeAgeDivision} />
                </div>
                <div className='TeamInfoCard'>
                    <div>Visitor Team Name</div>
                    <input type='text' onInput={handleChange} name='visitorShortName'
                        placeholder="Enter away team name"
                        value={teams.visitorShortName} />
                    <div>Division</div>
                    <input type='text' onInput={handleChange} name='visitorAgeDivision' value={teams.visitorAgeDivision} />
                </div>
            </div>

            <ReturnHome />
            {/* Cancel not implemented */}
        </div>
    );
}

export default SetTeamsMain;